import { useState, useEffect, Fragment, useRef } from "react";
import {
  useGetPlayListQuery,
  useGetTopFollowerPlaylistsQuery,
} from "../../components/apis/playlist";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../components/consts/routes.consts";
import { useGetArtistListQuery } from "../../components/apis/artistsApi";
import { useGetCuratorsListQuery } from "../../components/apis/curatorsApi";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

import {
  useGetBlogData3Query,
  useGetBlogDataQuery,
} from "../../components/apis/blogApi";
import { TabGroup, TabList, TabPanels, TabPanel, Tab } from "@headlessui/react";
import TopCuratorHome from "../../components/top-curator-home/top-curator-home";
import { ConnectSpotifyPopup } from "../../components/modals/connect-popup";
import Faq from "../../components/faq/faq";
import { isMobile } from "react-device-detect";
import { useGetHomeContentQuery } from "../../components/apis/homePageApi";
import ManagePlaylistsSVG from "../../assets/images/svg/manage-playlists.svg";
import { AnimatePresence, motion } from "framer-motion";
import { optimizeSpotifyImage } from "../../utils/imageOptimizer";
import {
  PlaylistGridSkeleton,
  ReviewsSkeleton,
  BlogSkeleton,
} from "../../components/skeletons";
import { DeferredSection } from "../../components/DeferredSection";

interface Playlist {
  _id: string;
  playlistName: string;
  totalFollowers: string;
  imageUrl: string;
  imageBroken?: boolean; 
  playlistId?: string;
}

export const Home: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [cookiesAccepted, setCookiesAccepted] = useState<any>();

  const { data: playlist } = useGetTopFollowerPlaylistsQuery<any>();
  const { data: blog } = useGetBlogDataQuery({});
  const { data: blogData } = useGetBlogData3Query({});
  const { data: homeContent } = useGetHomeContentQuery<any>();
  const { isSongSubmitRedirect, isShowConnectPopup, routeRedirectPage } =
    location?.state || {};

  const [sortedPlaylists, setSortedPlaylists] = useState<Playlist[]>([]);
  const [showScrollIcon, setShowScrollIcon] = useState(false);

  const [searchInput, setSearchInput] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSongSubmit, setIsSongSubmit] = useState(false);
  const [redirectPage, setRedirectPage] = useState("");
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const isLoggedIn = token && userId;
  const parts = searchInput.split("/");
  const lastPart = parts[parts.length - 1];
  const track = "https://open.spotify.com/track";
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [trackId, queryString] = lastPart.split("?");
  const { refetch } = useGetArtistListQuery<any>(
    { trackId: trackId },

    {
      skip: !searchInput.includes(track),
    }
  );
  const handleConnect = async () => {
    window.location.href =
      // "http://localhost:9090/api/auth/login?page=DASHBOARD";
      window.location.href =
        "https://api.pitchplaylists.com/api/auth/login?page=DASHBOARD";
  };
  const handleSearchSongConnect = async () => {
    setIsModalOpen(true);
    setIsSongSubmit(true);
    if (!searchInput.includes(track)) {
      setRedirectPage("SUBMIT-A-SONG");
    }
  };
  const handleSearchChange = (value: string) => {
    setSearchInput(value.trim());
    setSearchInput(value);
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollIcon(window.scrollY > 400);
      setShowScrollIcon(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (location.state) {
      setIsModalOpen(true);
      setIsSongSubmit(isSongSubmitRedirect);
      setRedirectPage(routeRedirectPage);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location, navigate]);

  useEffect(() => {
    if (playlist) {
      const sorted = [...playlist].sort((a, b) => {
        return parseInt(b.totalFollowers, 10) - parseInt(a.totalFollowers, 10);
      });
      setSortedPlaylists(sorted);
    }
  }, [playlist]);

  const truncateString = (str: string, num: number): string => {
    if (!str) return "";
    return str.length > num ? str.substring(0, num) + "..." : str;
  };

  useEffect(() => {
    const storedValue = localStorage.getItem("cookies_accepted");
    setCookiesAccepted(storedValue);
  }, []);

  const [isPlaylistSubmit, setIsPlaylistSubmit] = useState(false);
  const playlistUrl = "https://open.spotify.com/playlist";
  const [searchPlaylist, setSearchPlaylist] = useState<string>("");
  const part = searchPlaylist.split("/");
  const lastPartOfPlaylist = part[part.length - 1];
  const [playlistId, queryStrings] = lastPartOfPlaylist.split("?");
  const { refetch: refetchPlaylist } = useGetCuratorsListQuery<any>(
    { playlistId: playlistId },
    {
      skip: !searchPlaylist.includes(playlistUrl),
    }
  );
  const handleSubmitPLaylistConnect = async () => {
    if (!searchPlaylist.includes(playlistUrl)) {
      setRedirectPage("SUBMIT-A-PLAYLIST");
    }
    setIsModalOpen(true);
    setIsSongSubmit(false);
  };
  const handleChangePlaylist = (value: string) => {
    setSearchPlaylist(value);
  };
  const handleSubmitPLaylist = () => {
    if (searchPlaylist.includes(playlistUrl)) {
      if (isLoggedIn) {
        refetchPlaylist({ playlistId: playlistId }).then(
          (response: { data: any }) => {
            navigate(ROUTES.CONFIRM_PLAYLIST, {
              state: { playlistData: response.data },
            });
            if (response) {
              window.localStorage.setItem("playlist", "playlist");
            }
          }
        );
      } else {
        handleSubmitPLaylistConnect();
      }
    } else {
      handleSubmitPLaylistConnect();
    }
  };

  useEffect(() => {
    if (searchInput.includes(track)) {
      if (isLoggedIn) {
        const currentTrackId = searchInput.split("/").pop()?.split("?")[0];
        refetch({ trackId: currentTrackId }).then(async (response: any) => {
          if (response.status === "fulfilled" && response.data) {
            const trackData = response.data;
            
            // Navigate to confirmation screen - banned artist check will happen on Continue click
            navigate(ROUTES.SUBMIT_A_SONG_1, {
              state: { trackData: trackData },
            });
          } else {
            console.error("Unexpected status:", response.status);
            navigate(ROUTES.PAGE_NOT_FOUND);
          }
        });
      } else {
        handleSearchSongConnect();
      }
    } else {
      setTimeout(() => {
        setSearchInput("");
      }, 1000);
    }
  }, [refetch]);

  useEffect(() => {
    if (isMobile) {
      if (searchInput.includes(track)) {
        if (isLoggedIn) {
          const currentTrackId = searchInput.split("/").pop()?.split("?")[0];
          refetch({ trackId: currentTrackId }).then((response: any) => {
            if (response.status === "fulfilled") {
              navigate(ROUTES.SUBMIT_A_SONG_1, {
                state: { trackData: response.data },
              });
            } else {
              console.error("Unexpected status:", response.status);
              navigate(ROUTES.PAGE_NOT_FOUND);
            }
          });
        } else {
          handleSearchSongConnect();
        }
      } else {
        setTimeout(() => {
          setSearchInput("");
        }, 1000);
      }
    }
  }, [searchInput]);

  useEffect(() => {
    if (isMobile) {
      if (searchPlaylist.includes(playlistUrl)) {
        if (isLoggedIn) {
          refetchPlaylist({ playlistId: playlistId }).then(
            (response: { data: any }) => {
              navigate(ROUTES.CONFIRM_PLAYLIST, {
                state: { playlistData: response.data },
              });
              if (response) {
                window.localStorage.setItem("playlist", "playlist");
              }
            }
          );
        } else {
          handleSubmitPLaylistConnect();
        }
      } else {
        setTimeout(() => {
          setSearchPlaylist("");
        }, 1000);
      }
    }
  }, [searchPlaylist]);

  const forWhoTabs = [
    {
      title: "For artists",

      block: homeContent?.contentTypeData[0]?.artists_section,
    },
    {
      title: "For curators",

      block: homeContent?.contentTypeData[0]?.curator_section,
    },
  ];

  useEffect(() => {
    if (window.location.href.includes("features")) {
      document.querySelector("#features")?.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    } else if (window.location.href.includes("top-playlists")) {
      document.querySelector("#top-playlists")?.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }
  }, []);
  const [reviews, setReviews] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const fetchReviewApi = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://api.pitchplaylists.com/api/reviewpage"
        // "http://localhost:9090/api/reviewpage"
      );
      const simplifiedData = response?.data?.reviewData.map((item: any) => {
        return {
          id: item.id,
          title: item.title || "Reviewer Title",
          description: item.description,
          image: item.image,
          category: item.category,
          rating: item.rating || 5,
          alt: item.alt || "Reviewer image",
        };
      });
      setReviews(simplifiedData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [featuresData, setFeaturesData] = useState<any>([]);

  const fetchFeaturesApi = async () => {
    try {
      const response = await axios.get(
        "https://api.pitchplaylists.com/api/feature"
      );
      setFeaturesData(response?.data?.featureData);
    } catch (error) {
      console.log(error);
    }
  };
  let didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;

    fetchReviewApi();
    fetchFeaturesApi();
  }, []);

  const handleImageError = (index: number) => {
  setSortedPlaylists((prev) => {
    const updated = [...prev];
    updated[index] = {
      ...updated[index],
      imageBroken: true,
    };
    return updated;
  });
};

  if (!homeContent) {
    return (
      <div className="flex items-center justify-center h-full min-h-[700px]">
        <CircularProgress
          size={40}
          aria-label="Home Page Content"
          sx={{
            color: "#ffffff",
            display: "inline-flex",
            alignItems: "center",
            fontWeight: 900,
          }}
        />
      </div>
    );
  }

  return (
    <>
      <div className="main-banner-wrapper">
        <section className="main-banner">
          <div className="container">
            <div className="main-banner-content">
              <p
                className="content-text mb-4 md:text-base text-[12px] text-dark-gray"
                dangerouslySetInnerHTML={{
                  __html:
                    homeContent?.contentTypeData[0]?.banner_section
                      ?.sub_heading_1,
                }}
              ></p>
              <h1
                className="content-heading mb-5 2xl:text-[64px] lg:text-[50px] text-[32px] !leading-tight"
                dangerouslySetInnerHTML={{
                  __html:
                    homeContent?.contentTypeData[0]?.banner_section?.heading,
                }}
              ></h1>
              <div
                className="content-text mb-[48px] md:text-lg text-[14px] text-light-gray max-w-[620px] mx-auto"
                dangerouslySetInnerHTML={{
                  __html:
                    homeContent?.contentTypeData[0]?.banner_section
                      ?.sub_heading_2,
                }}
              ></div>
              <div className="relative inline-grid sm:max-w-[450px] max-w-[300px] w-full">
                <input
                  className="bg-[#fff] focus-visible:outline-0 placeholder:text-[#A2A2A2] w-full placeholder:underline md:py-[15px] placeholder:text-[12px] md:placeholder:text-[16px] md:text-base text-[12px]  sm:pr-[110px] py-[12px] sm:pl-[60px] pl-[45px] rounded-[999px] text-[#a2a2a2]"
                  placeholder="Insert Your Spotify Track Link"
                  onChange={(event) => handleSearchChange(event.target.value)}
                  value={searchInput}
                />
                <img
                  className="absolute md:left-[12px] left-[6px] md:top-[10.5px] sm:top-[4px] top-[6px]  sm:w-[35px] w-[30px] sm:h-[35px] h-[30px]"
                  src="/image/spoty-logocolor.webp"
                  alt="Spotify logo for Pitch Playlists"
                  title="Pitch Playlists on Spotify - Listen to curated playlists on Spotify"
                  height="30"
                  width="30"
                  loading="lazy"
                />
                <button
                  className="absolute md:right-[12px] right-[4px] md:top-[10.5px] top-[3.5px] bg-gradient text-base px-5 py-[5.5px] text-white rounded-full sm:flex hidden"
                  onClick={handleSearchSongConnect}
                >
                  Submit
                </button>
              </div>
            </div>
            <div className="banner-slider md:my-0 sm:my-6 mt-6 sm:mx-auto mx-[-20px] sm:h-[400px] max-sm:overflow-hidden max-sm:min-h-44  overflow-x-hidden">
              <div className="  flex items-end sm:gap-6 gap-2 justify-center ">
                <div className="mb-[-45px] sm:min-w-[145px] min-w-[40px] ">
                  <img
                    src="/image/studio-producers.webp"
                    alt="Studio producers at work"
                    title="Studio Producers Working on Music Tracks"
                    width="145"
                    height="186"
                    loading="lazy"
                    style={{ aspectRatio: "145 / 186" }}
                    className="w-full sm:rounded-[20px] rounded-[8px] "
                  />
                </div>
                <div className="mb-[-25px]  sm:min-w-[190px] min-w-[70px]">
                  <img
                    src="/image/mixing-and-mastering.webp"
                    alt="Mixing engineers working"
                    title="Mixing and Mastering Engineers at Work in the Studio"
                    width="195"
                    height="253"
                    loading="lazy"
                    style={{ aspectRatio: "195 / 253" }}
                    className="w-full sm:rounded-[20px] rounded-[8px]"
                  />
                </div>
                <div className="sm:min-w-[225px] min-w-[90px] ">
                  <img
                    src="/image/DJ-on-stage.webp"
                    alt="DJ performing on stage"
                    title="Live DJ Performance on Stage during a Music Event"
                    width="225"
                    height="289"
                    loading="eager"
                    fetchPriority="high"
                    style={{ aspectRatio: "225 / 289" }}
                    className="w-full sm:rounded-[20px] rounded-[8px]"
                  />
                </div>
                <div className="sm:min-w-[230px] min-w-[110px] ">
                  <img
                    src="/image/singer-songwriters.webp"
                    alt="Singer-songwriters on stage"
                    title="Singer-songwriters performing live"
                    width="235"
                    height="314"
                    loading="eager"
                    fetchPriority="high"
                    style={{ aspectRatio: "235 / 314" }}
                    className="w-full sm:rounded-[20px] rounded-[8px]"
                  />
                </div>
                <div className="sm:min-w-[225px] min-w-[90px]">
                  <img
                    src="/image/rappers.webp"
                    alt="Rappers on stage"
                    title="Live performance by rappers"
                    width="225"
                    height="289"
                    loading="lazy"
                    style={{ aspectRatio: "225 / 289" }}
                    className="w-full sm:rounded-[20px] rounded-[8px]"
                  />
                </div>
                <div className="mb-[-25px] sm:min-w-[190px] min-w-[70px] ">
                  <img
                    src="/image/highlighting.webp"
                    alt="Highlighted content"
                    title="Highlighting important content"
                    width="192"
                    height="252"
                    loading="lazy"
                    style={{ aspectRatio: "192 / 252" }}
                    className="w-full sm:rounded-[20px] rounded-[8px]"
                  />
                </div>
                <div className="mb-[-45px]  sm:min-w-[145px] min-w-[40px]">
                  <img
                    src="/image/production.webp"
                    alt="Production process"
                    title="Production process in action"
                    width="145"
                    height="192"
                    loading="lazy"
                    style={{ aspectRatio: "145 / 192" }}
                    className="w-full sm:rounded-[20px] rounded-[8px]"
                  />
                </div>
              </div>
            </div>
          </div>
          <ConnectSpotifyPopup
            setIsModalOpen={setIsModalOpen}
            isModalOpen={isModalOpen}
            isSongSubmit={isSongSubmit}
            trackId={trackId}
            playlistId={playlistId}
            page={redirectPage}
          />
        </section>
        <TopCuratorHome props={homeContent?.contentTypeData[0]?.top_curator} />
      </div>
      <section
        id="top-playlists"
        className="genres-section lg:pb-[140px] pb-[100px] pt-11"
      >
        <div className="container">
          <div className="geners-content ">
            <div className="geners-heading-part text-center md:mb-[80px] mb-[40px] m-[auto] max-w-[1038px]">
              <p
                className="md:text-[18px] text-[14px] font-[400] leading-[130%] text-[#878DA1] mb-[16px]"
                dangerouslySetInnerHTML={{
                  __html:
                    homeContent?.contentTypeData[0]?.playlist_section
                      ?.sub_heading_1,
                }}
              ></p>
              <div className="lg:text-[55px] text-[28px] font-[700] leading-[110%] text-[#fff] mb-[32px]">
                {homeContent?.contentTypeData[0]?.playlist_section?.heading
                  ?.split(" ")
                  .slice(0, 7)
                  .join(" ")}{" "}
                <span className="gradient-text">
                  {homeContent?.contentTypeData[0]?.playlist_section?.heading
                    ?.split(" ")
                    .slice(7)
                    .join(" ")}
                </span>
              </div>

              <div className="md:text-[20px] text-[16px] font-[400] leading-[130%] text-[#DDDDDD]">
                {homeContent?.contentTypeData[0]?.playlist_section?.sub_heading_2
                  ?.split(" ")
                  .slice(0, 8)
                  .join(" ")}{" "}
                <p className="-mt-1">
                  {homeContent?.contentTypeData[0]?.playlist_section?.sub_heading_2
                    ?.split(" ")
                    .slice(8)
                    .join(" ")}{" "}
                </p>
              </div>
            </div>
            {sortedPlaylists && sortedPlaylists.length > 0 ? (
              <div className="geners-box-content md:mb-[64px] mb-[32px] grid  2xl:grid-cols-3 md:grid-cols-2 grid-cols gap-[24px] flex-wrap">
                {sortedPlaylists
                  ?.filter((val: any) => !val.imageBroken && val?.imageUrl)
                  ?.slice(0, 6)
                  ?.map((val: any, index: any) => (
                <div
                  className="geners-list flex flex-1 bg-[#0E0E10] p-4 rounded-[20px] gap-5"
                  key={`Gen__${index}`}
                >
                  <div className="geners-img">
                    {" "}
                    <Link
                      to={val?.playlistUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={optimizeSpotifyImage(val.imageUrl, 168, 168)}
                        alt="Spotify playlist cover"
                        title="Spotify Playlist Artwork Featuring Various Artists"
                        width="168"
                        height="168"
                        loading="lazy"
                        onError={()=>handleImageError(index)}
                        style={{ aspectRatio: "1 / 1" }}
                      />
                    </Link>
                  </div>
                  <div className="geners-detail  w-full ">
                    <div className="full-logo mb-4">
                      <Link
                        to={"https://open.spotify.com/"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/image/Full_Logo_Green.webp"
                          alt="Full logo in green"
                          title="Full logo in green"
                          width="102"
                          height="29"
                          loading="lazy"
                        />
                      </Link>
                    </div>
                    <h2 className="text-[#fff] text-lg font-semibold mb-1">
                      <Link
                        to={val?.playlistUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline underline-offset-2"
                      >
                        {truncateString(val?.playlistName, 26)}
                      </Link>
                    </h2>

                    <p className="geners-by text-[#878DA1] text-base font-[500] mb-4 flex items-center gap-[5px]">
                      By{" "}
                      <Link
                        to={`https://open.spotify.com/user/${val?.playlistOwnerId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="geners-by text-[#878DA1] text-base font-medium hover:text-white"
                      >
                        {" "}
                        {val.ownerName}
                      </Link>
                    </p>

                    <div className="geners-follow-deatils flex justify-between items-center sm:pr-6">
                      <div className="geners-by text-[#4B4F55] lg:text-base md:text-sm text-xs  font-[500] leading-[130%] ">
                        <p>Followers:</p>
                        <span> {val.totalFollowers}</span>
                      </div>
                      <div className="bg-[#82879833] h-[40px] w-[2px]"></div>
                      <div className="geners-by text-[#4B4F55] lg:text-base md:text-sm text-xs  font-[500] leading-[130%]">
                        <p># of Tracks:</p>
                        <span>{val.totalTracks}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              </div>
            ) : (
              <PlaylistGridSkeleton />
            )}
            <div className="geners-action">
              <button
                className="button button--primary flex gap-3 items-center  mx-auto"
                onClick={() => {
                  setIsModalOpen(true);
                  setIsSongSubmit(true);
                  setRedirectPage("SUBMIT-A-SONG");
                }}
              >
                <span className="">Submit your song</span>
                <span className="w-[30px] h-[30px] ">
                  <img
                    src="/image/Shape-music.webp"
                    alt="Musical Shape Icon"
                    title="Explore the Shape of Music"
                    width="30"
                    height="29"
                    loading="lazy"
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="playlist-frame lg:md:pb-24 pb-20 relative">
        <div className="absolute bottom-[10px] left-[15%] sm:hidden block ">
          <img
            src="/image/top-chart.webp"
            alt="Top Chart"
            title="View Top Music Charts"
            loading="lazy"
            width=""
            height=""
          />
        </div>
        <div className="absolute top-[2px] sm:hidden block">
          <img
            src="/image/viral-img.webp"
            alt="Viral-Img"
            title="See What's Trending Now"
          />
        </div>
        <div className="absolute right-0 bottom-[120px] sm:hidden block">
          <img
            src="/image/favt-img.webp"
            alt="Fav-Img"
            title="View Your Favorites"
            width=""
            height=""
            loading="lazy"
          />
        </div>
        <div className="container">
          <div className="bg-cover bg-center rounded-[50px] relative">
            <div className="absolute top-0 left-0 w-full h-full -z-10 text-center">
              <img
                src={ManagePlaylistsSVG}
                alt="Manage Playlists Graphic"
                className="w-full h-full object-contain object-center"
              />
            </div>
            <div className="max-w-[716px] m-[auto] text-center h-[100%] flex flex-col items-center justify-center sm:px-[25px] px-[24px]  sm:py-[120px] py-[40px]">
              <h2
                className="2xl:text-[64px] lg:text-[50px] text-[32px]  font-[700] leading-[100%] text-[#fff] mb-[32px]"
                dangerouslySetInnerHTML={{
                  __html:
                    homeContent?.contentTypeData[0]?.submit_playlist_section
                      ?.heading,
                }}
              ></h2>
              <p className="lg:text-[20px] text-[16px] leading-[130%] md:mb-12 mb-8 text-[#fff]">
                {homeContent?.contentTypeData[0]?.submit_playlist_section?.sub_heading_1
                  ?.split(" ")
                  .slice(0, 11)
                  .join(" ")}{" "}
                <span className="text-gradient2">
                  {homeContent?.contentTypeData[0]?.submit_playlist_section?.sub_heading_1
                    ?.split(" ")
                    .slice(11)
                    .join(" ")}
                </span>
              </p>
              <div className="frame-action bg-[#121020] rounded-[50px] max-w-[504px]">
                <div className="relative inline-grid md:w-[450px] sm:max-w-none max-w-[290px] w-full md:min-w-none min-w-[250px] ">
                  <input
                    className=" bg-[transparent] focus-visible:border-0 placeholder:text-[12px] md:placeholder:text-[14px] md:text-[14px] text-[12px] placeholder:text-[#A2A2A2] placeholder:underline md:py-[14px] py-[12px] md:pl-[60px] pl-[50px] md:pr-[140px]  pr-[16px] rounded-[999px] text-[#a2a2a2] w-full "
                    placeholder="Insert Your Spotify Playlist Link"
                    value={searchPlaylist}
                    onChange={(event: any) =>
                      handleChangePlaylist(event.target.value)
                    }
                  />
                  <img
                    src="/image/spoty-logocolor.webp"
                    alt="Spotify-Logo-Color"
                    title="Listen on Spotify"
                    width="32"
                    height="32"
                    loading="lazy"
                    className="absolute left-[10px]  md:top-[7px] top-[5px]  md:w-[35px] md:h-[35px] w-[32px] h-[32px] "
                  />
                  <button
                    className="absolute right-[12px] md:top-[6.5px] top-[6px] bg-white text-base px-5 py-[5.5px] text-[#020202] font-semibold rounded-full md:flex hidden"
                    onClick={handleSubmitPLaylist}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="features"
        className="features-section md:pb-[140px] pb-20 pt-11"
      >
        <div className="container">
          <div className="features-content">
            <div className="features-content_header text-center m-[auto] max-w-[1038px]">
              <p
                className="lg:text-[20px] text-[14px] font-[400] text-[#878DA1] leading-[130%] mb-[16px]"
                dangerouslySetInnerHTML={{
                  __html:
                    homeContent?.contentTypeData[0]?.features_section
                      ?.sub_heading_1,
                }}
              ></p>
              <h2 className="lg:text-[64px] text-[32px] font-[700] text-[#fff] leading-[120%] mb-[64px]">
                <span className="gradient-text-reverse">
                  {homeContent?.contentTypeData[0]?.features_section?.heading
                    ?.split(" ")
                    .slice(0, 2)
                    .join(" ")}{" "}
                </span>
                {homeContent?.contentTypeData[0]?.features_section?.heading
                  ?.split(" ")
                  .slice(2)
                  .join(" ")}{" "}
              </h2>
            </div>
            <div className="features-content-list grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
              <div className="features-content-box p-[24px]  rounded-[20px] ">
                <div className="mb-[16px]">
                  <img
                    src="/image/features.webp"
                    alt="Male singer performing, part of the visual content on Pitchplaylists homepage"
                    title="Featured Artist Performance"
                    width="316"
                    height="178.88"
                    className="mx-auto"
                  />
                </div>
                <div className="flex gap-3">
                  <div>
                    <img
                      src="/image/Shape-headphone.webp"
                      alt="Shape-HeadPhone"
                      title="Listen Now"
                      width="26"
                      height="26"
                      loading="lazy"
                      className="md:min-w-[26px]   min-w-[22px]"
                    />
                  </div>
                  <div className="">
                    <h2 className="text-[#fff] md:text-[20px] text-[18px] font-[600] leading-[130%] mb-[16px]">
                      {featuresData[0]?.title}
                    </h2>
                    <span className="text-[#878DA1] md:text-base text-sm font-[400] md:leading-[130%] leading-[120%]">
                      {featuresData[0]?.description}
                    </span>
                  </div>
                </div>
              </div>
              <div className="features-content-box p-[24px] rounded-[20px] ">
                <div className="mb-[16px]">
                  <img
                    src="/image/features2.webp"
                    alt="Spotify music genre cards, part of the visual content on Pitchplaylists homepage"
                    title="Explore Music by Genre"
                    width="316"
                    height="178.88"
                    loading="lazy"
                    className="mx-auto"
                  />
                </div>
                <div className="flex gap-3">
                  <div>
                    <img
                      src="/image/Crown.webp"
                      alt="Crown"
                      title="Premium Member"
                      width="30"
                      height="30"
                      loading="lazy"
                      className="md:min-w-[30px] min-w-[25px]"
                    />
                  </div>
                  <div className="">
                    <h2 className="text-[#fff] md:text-[20px] text-[18px] font-[600] leading-[130%] mb-[16px]">
                      {featuresData[1]?.title}
                    </h2>
                    <span className="text-[#878DA1] md:text-base text-sm font-[400] md:leading-[130%] leading-[120%]">
                      {featuresData[1]?.description}
                    </span>
                  </div>
                </div>
              </div>
              <div className="features-content-box p-[24px]  rounded-[20px] ">
                <div className="mb-[16px]">
                  <img
                    src="/image/features3.webp"
                    alt="Spotify logo displayed on a smart TV, part of the visual content on the Pitchplaylists homepage"
                    title="Spotify on Smart TV"
                    width="316"
                    height="178.88"
                    loading="lazy"
                    className="mx-auto"
                  />
                </div>
                <div className="flex gap-3">
                  <div>
                    <img
                      src="/image/Fire.webp"
                      alt="Fire Icon "
                      title="Trending Now"
                      width="30"
                      height="30"
                      loading="lazy"
                      className="md:min-w-[30px] min-w-[25px]"
                    />
                  </div>
                  <div className="">
                    <h2 className="text-[#fff] md:text-[20px] text-[18px] font-[600] leading-[130%] mb-[16px]">
                      {featuresData[2]?.title}
                    </h2>
                    <span className="text-[#878DA1] md:text-base text-sm font-[400] md:leading-[130%] leading-[120%]">
                      {featuresData[2]?.description}
                    </span>
                  </div>
                </div>
              </div>
              <div className="features-content-box p-[24px] rounded-[20px]">
                <div className="mb-[16px]">
                  <img
                    src="/image/features4.webp"
                    alt="Spotify playlist on phone, air pods, laptop, part of the visual content on the Pitchplaylists homepage"
                    title="Listen to Spotify Anywhere"
                    width="316"
                    height="178.88"
                    loading="lazy"
                    className="mx-auto"
                  />
                </div>
                <div className="flex gap-3">
                  <div>
                    <img
                      src="/image/Play.webp"
                      alt="PlaySong"
                      title="Play Song "
                      width="30"
                      height="30"
                      loading="lazy"
                      className="md:min-w-[30px] min-w-[25px]"
                    />
                  </div>
                  <div className="">
                    <h2 className="text-[#fff] md:text-[20px] text-[18px] font-[600] leading-[130%] mb-[16px]">
                      {featuresData[3]?.title}
                    </h2>
                    <span className="text-[#878DA1] md:text-base text-sm font-[400] md:leading-[130%] leading-[120%]">
                      {featuresData[3]?.description}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="submitcurator-section">
        <section className="md:pb-[140px] pb-[75px] ">
          <div className="container">
            <TabGroup className="submitcurator-content">
              <TabList className="submitcurator-content_action flex md:gap-4 lg:mb-[90px] mb-[40px] md:p-0 p-1 md:bg-transparent bg-[#0E0E10] rounded-[999px] ">
                {forWhoTabs.map(({ title }) => (
                  <Tab key={title} as={Fragment}>
                    {({ selected }) => (
                      <button
                        className={`rounded-[50px] md:text-base text-sm py-[14px] px-[30px] font-semibold md:basis-auto basis-full ${
                          selected
                            ? "text-[#020202] bg-[#58F2A9]"
                            : "text-[#fff] bg-[#0E0E10]"
                        }`}
                      >
                        {title}
                      </button>
                    )}
                  </Tab>
                ))}
              </TabList>
              <TabPanels>
                <TabPanel className="submitcurator-content-box grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 xl:gap-[50px] gap-[30px]">
                  {homeContent?.contentTypeData[0]?.artists_section?.map(
                    (item: any, index: any) => (
                      <div
                        key={`submitcurator_${index}`}
                        className={index === 1 ? `mt-[110px]` : ""}
                      >
                        <div className="border-[1px solid rgba(135, 141, 161, 0.4)] md:mb-[40px] mb-6">
                          <img
                            src={
                              `https://api.pitchplaylists.com/${item.image}` ||
                              ""
                            }
                            alt={item.alt || ""}
                            title={item.title || "Image from Pitch Playlists"}
                            width="468"
                            height="341"
                            loading="lazy"
                            style={{ aspectRatio: "468 / 341" }}
                            className="mx-auto"
                          />
                        </div>
                        <div className="">
                          <h2
                            className="md:text-[22px] text-lg text-[#fff] leading-[130%] md:mb-6 mb-5"
                            dangerouslySetInnerHTML={{
                              __html: item?.title,
                            }}
                          ></h2>
                          <p
                            className="md:text-lg text-sm text-[#878DA1] leading-[130%]"
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          ></p>
                        </div>
                      </div>
                    )
                  )}
                </TabPanel>
                <TabPanel className="submitcurator-content-box grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 xl:gap-[50px] gap-[30px]">
                  {homeContent?.contentTypeData[0]?.curator_section?.map(
                    (item: any, index: any) => (
                      <div
                        className={index === 1 ? `mt-[110px]` : ""}
                        key={`submitcurator-content__${index}`}
                      >
                        <div className="border-[1px solid rgba(135, 141, 161, 0.4)] md:mb-[40px] mb-6">
                          <img
                            src={
                              `https://api.pitchplaylists.com/${item.image}` ||
                              ""
                            }
                            alt={item.alt ? item.alt : "Curator profile image"}
                            title={item.title || "Curator's Image"}
                            width="468"
                            height="341"
                            loading="lazy"
                            className="mx-auto"
                          />
                        </div>
                        <div className="">
                          <h2 className="md:text-[22px] text-lg text-[#fff] leading-[130%] md:mb-6 mb-5">
                            {item?.title}
                          </h2>
                          <p className="md:text-lg text-sm text-[#878DA1] leading-[130%]">
                            {item?.description}
                          </p>
                        </div>
                      </div>
                    )
                  )}
                </TabPanel>
              </TabPanels>
            </TabGroup>
          </div>
        </section>
        <DeferredSection fallback={<div className="min-h-[300px]" />}>
          <section className="testimonial-section overflow-hidden md:pb-[140px] pb-[75px]">
            <div className="container">
              <div className="testimonial-content">
                <div className="testimonial-content_header text-center m-[auto] max-w-[1038px]">
                  <p
                    className="md:text-[18px] text-[14px] font-[400] text-[#878DA1] leading-[130%] mb-[16px]"
                    dangerouslySetInnerHTML={{
                      __html:
                        homeContent?.contentTypeData[0]?.review_section
                          ?.sub_heading,
                    }}
                  ></p>
                  <h2
                    className="md:text-[50px] text-[28px] font-bold text-white leading-[120%] md:mb-24 mb-14"
                    dangerouslySetInnerHTML={{
                      __html:
                        homeContent?.contentTypeData[0]?.review_section?.heading,
                    }}
                  ></h2>
                </div>
                <div className="testimonial-section-wrapper min-h-[300px] ">
                  {loading ? (
                    <ReviewsSkeleton />
                  ) : reviews.length === 0 ? (
                    <div className="flex items-center justify-center h-full min-h-[300px]">
                      <CircularProgress
                        size={40}
                        sx={{
                          color: "#ffffff",
                          display: "inline-flex",
                          alignItems: "center",
                          fontWeight: 900,
                        }}
                      />
                    </div>
                  ) : (
                    <div className="testimonial-content-details grid xl:grid-cols-[repeat(4,490px)] sm:grid-cols-2 grid-cols-1 gap-x-6 gap-y-14">
                    {reviews.slice(0, 4).map((review: any, index: number) => {
                      return (
                        <div
                          key={
                            review?.id
                              ? `review_${review.id}`
                              : `review_index_${index}`
                          }
                          className={`testimonial-list-2 relative h-full  ${
                            index === 3 ? "testimonial-list-blur" : ""
                          }`}
                        >
                          {review?.image ? (
                            <div className="img-testimonial absolute md:top-[-44px] top-[-28px] left-[32px] md:w-[64px] md:h-[64px]  w-[48px]  h-[48px] rounded-[100%] overflow-hidden z-[9]">
                              <img
                                className="h-[100%] object-cover"
                                src={`https://api.pitchplaylists.com/${review.image}`}
                                alt={review.alt || "Review Images"}
                                width="64"
                                height="64"
                                title={review.title || ""}
                                loading="lazy"
                                style={{ aspectRatio: "1 / 1" }}
                              />
                            </div>
                          ) : (
                            <div className="img-testimonial absolute md:top-[-44px] top-[-28px] left-[32px] md:w-[64px] md:h-[64px]  w-[48px]  h-[48px] rounded-[100%] overflow-hidden">
                              <svg
                                width="64"
                                height="64"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40ZM30 23C30 21.3431 28.6569 20 27 20H13C11.3431 20 10 21.3431 10 23V24C10 27.9429 13.719 32 20 32C26.281 32 30 27.9429 30 24V23ZM25.5 12.5C25.5 9.46243 23.0376 7 20 7C16.9624 7 14.5 9.46243 14.5 12.5C14.5 15.5376 16.9624 18 20 18C23.0376 18 25.5 15.5376 25.5 12.5Z"
                                  fill="#878DA1"
                                />
                              </svg>
                            </div>
                          )}

                          <div className="testimonial-review p-[24px] pt-[32px] rounded-[20px] bg-[#0E0E10]">
                            <div className="view-message">
                              <div className="lg:text-[16px] text-[14px] font-[400] text-white leading-normal lg:pb-5 pb-4 divide-x-3">
                                <div
                                  className="text-white text-sm"
                                  dangerouslySetInnerHTML={{
                                    __html: review.description,
                                  }}
                                ></div>
                              </div>
                              <span className="divider"></span>
                              <div className="testimonial-review-detail flex justify-between items-center lg:mt-5 mt-4">
                                <div className="name-detail ">
                                  <h2 className="lg:text-[20px] text-[16px]  font-[600] text-[#fff] leading-[130%] mb-[4px]">
                                    {review.title}
                                  </h2>
                                  <p className="lg:text-[18px]  text-[15px] font-[400] text-[#878DA1] leading-[130%]">
                                    {review.category || "Artist"}
                                  </p>
                                </div>
                                <div className="flex gap-[7px]">
                                  {[...Array(5)].map((_, i) => (
                                    <span key={i}>
                                      {i < review.rating ? (
                                        <span>
                                          <svg
                                            width="16"
                                            height="15"
                                            viewBox="0 0 16 15"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className=""
                                          >
                                            <path
                                              d="M8.8025 0.830005L10.4208 4.09416C10.5425 4.34 10.7775 4.51002 11.05 4.54918L14.7858 5.08914C15.4708 5.18831 15.7442 6.02832 15.2483 6.50999L12.5475 9.13084C12.35 9.3225 12.26 9.59833 12.3066 9.86916L12.9241 13.4558C13.0491 14.1833 12.285 14.7383 11.63 14.3958L8.39 12.7C8.14667 12.5725 7.85664 12.5725 7.61414 12.7L4.37663 14.3942C3.7208 14.7375 2.95411 14.1816 3.07994 13.4525L3.69752 9.86916C3.74418 9.59833 3.65413 9.3225 3.45663 9.13084L0.755825 6.50999C0.259158 6.02832 0.532434 5.18831 1.21827 5.08914L4.95413 4.54918C5.22579 4.51002 5.4608 4.34 5.5833 4.09416L7.20165 0.830005C7.52748 0.167505 8.47416 0.167505 8.8025 0.830005Z"
                                              fill="#58F2A9"
                                            />
                                          </svg>
                                        </span>
                                      ) : (
                                        <span>
                                          <svg
                                            width="16"
                                            height="15"
                                            viewBox="0 0 16 15"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M8.8025 0.830005L10.4208 4.09416C10.5425 4.34 10.7775 4.51002 11.05 4.54918L14.7858 5.08914C15.4708 5.18831 15.7442 6.02832 15.2483 6.50999L12.5475 9.13084C12.35 9.3225 12.26 9.59833 12.3066 9.86916L12.9241 13.4558C13.0491 14.1833 12.285 14.7383 11.63 14.3958L8.39 12.7C8.14667 12.5725 7.85664 12.5725 7.61414 12.7L4.37663 14.3942C3.7208 14.7375 2.95411 14.1816 3.07994 13.4525L3.69752 9.86916C3.74418 9.59833 3.65413 9.3225 3.45663 9.13084L0.755825 6.50999C0.259158 6.02832 0.532434 5.18831 1.21827 5.08914L4.95413 4.54918C5.22579 4.51002 5.4608 4.34 5.5833 4.09416L7.20165 0.830005C7.52748 0.167505 8.47416 0.167505 8.8025 0.830005Z"
                                              fill="#878DA1"
                                              fillOpacity="0.4"
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    </div>
                  )}
                </div>
                <div className="flex justify-center md:mt-[64px] mt-10 ">
                  <Link to={"/reviews"} className="button button--primary">
                    Read all reviews
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </DeferredSection>
      </div>
      <DeferredSection fallback={<div className="min-h-[400px]" />}>
        <section className="lastest-news md:pb-[140px] pb-[75px] ">
          <div className="container">
            <div className="flex sm:items-center items-start  gap-4 sm:flex-row flex-col  justify-between lg:mb-[50px]  mb-[35px]">
              <div>
                <h2
                  className="md:text-[50px] text-[28px] font-[700] text-[#ffffff] leading-[1.2]"
                  dangerouslySetInnerHTML={{
                    __html:
                      homeContent?.contentTypeData[0]?.blog_section?.heading,
                  }}
                ></h2>
                <p className="md:text-[20px] text-base text-[#DDDDDD] font-normal lg:mt-6 mt-4">
                  {homeContent?.contentTypeData[0]?.blog_section?.sub_heading}
                </p>
              </div>
              <div className="text-center">
                <a
                  href="https://pitchplaylists.com/blog"
                  rel="noopener noreferrer"
                  className="button button--primary"
                >
                  Go to Blog
                </a>
              </div>
            </div>
            {loading ? (
              <BlogSkeleton />
            ) : Array.isArray(blog) && blog?.length > 0 ? (
            <div className="flex lg:flex-row flex-col lg:gap-0 gap-6">
              <div className="lg:w-[40%] md:overflow-y-auto overflow-x-auto rounded-[20px] lg:max-h-[611px] md:max-h-[675px] max-h-[611px] pr-2">
                <div className="flex md:flex-col flex-row gap-4">
                  {blog?.map((post) => (
                    <div
                      key={post.id}
                      className="bg-[#0E0E10] md:min-w-auto min-w-full flex flex-col justify-end rounded-[20px] relative overflow-hidden"
                    >
                      <a href={post.link} className="block aspect-video">
                        <img
                          src={
                            post?._embedded?.["wp:featuredmedia"]?.[0]
                              ?.source_url
                              ? post._embedded[
                                  "wp:featuredmedia"
                                ][0].source_url.replace(
                                  /(\.jpg|\.jpeg|\.png|\.webp)$/,
                                  "-768x432$1"
                                )
                              : "/image/placeholder.jpg"
                          }
                          alt={post.title.rendered}
                          title={`Featured image for "${post.title.rendered}"`}
                          loading="lazy"
                          width={768}
                          height={432}
                          className="w-full h-full object-cover"
                        />
                      </a>
                      <div className="px-6 py-5">
                        <p className="text-[#4B4F55] text-base mb-3 font-[500]">
                          {(() => {
                            const date = new Date(post?.date);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            );
                            const year = date.getFullYear();
                            return `${day}.${month}.${year}`;
                          })()}
                        </p>
                        <div className="border-none">
                          <p className="text-[#ffffff] md:text-[18px] text-base md:mb-3 mb-2 font-semibold line-clamp-1">
                            <a
                              href={post.link}
                              className="hover:underline underline-offset-2 inline"
                              dangerouslySetInnerHTML={{
                                __html: post?.title.rendered,
                              }}
                            ></a>
                          </p>
                          <p
                            className="text-[#FFFFFF99] md:text-base text-sm mb-3 font-[500] line-clamp-5"
                            dangerouslySetInnerHTML={{
                              __html: post?.excerpt.rendered,
                            }}
                          />
                          <a
                            className="text-[#58F2A9] hover:text-[#1ed760] max-sm:text-sm font-[400] underline underline-offset-2"
                            href={post?.link}
                            aria-label={`Read More about ${post.title.rendered}`}
                          >
                            Read more
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lg:w-[60%] lg:pl-[40px] lg:block grid sm:grid-cols-2 grid-cols-1 gap-[24px]">
                {(blogData?.slice(0, 3) || []).map((post) => (
                  <div
                    className="flex items-stretch lg:flex-row flex-col bg-[#0E0E10] rounded-[20px] overflow-hidden lg:mb-6 last:mb-0 bg-cover bg-center bg-no-repeat"
                    key={post.id}
                  >
                    <a
                      href={post.link}
                      className="block aspect-video sm:min-w-[300px] w-full"
                    >
                      <img
                        src={
                          post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url
                            ? post._embedded[
                                "wp:featuredmedia"
                              ][0].source_url.replace(
                                /(\.jpg|\.jpeg|\.png|\.webp)$/,
                                "-300x169$1"
                              )
                            : "/image/placeholder.jpg"
                        }
                        alt={post.title.rendered}
                        title="Blog Page Images"
                        width={300}
                        height={169}
                        loading="lazy"
                        className="w-full object-cover h-full"
                      />
                    </a>
                    <div className="lg:px-[24px] lg:py-5 p-4 lg:grid grid-cols-[1fr_0.4fr]">
                      <p className="text-[#4B4F55] font-[500] col-start-2 -col-end-1 lg:text-right max-lg:mb-1">
                        {(() => {
                          const date = new Date(post?.date);
                          const day = String(date.getDate()).padStart(2, "0");
                          const month = String(date.getMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          const year = date.getFullYear();
                          return `${day}.${month}.${year}`;
                        })()}
                      </p>
                      <p className="text-[#ffffff] lg:text-lg mb-[9px] font-semibold -order-1 line-clamp-2">
                        <a
                          href={post.link}
                          className="hover:underline underline-offset-2 inline"
                          dangerouslySetInnerHTML={{
                            __html: post?.title.rendered,
                          }}
                        ></a>
                      </p>
                      <p
                        className="text-[#FFFFFF99] max-lg:text-sm leading-snug font-medium line-clamp-3 max-lg:mb-2"
                        dangerouslySetInnerHTML={{
                          __html: post.excerpt.rendered,
                        }}
                      />
                      <a
                        className="text-[#58F2A9] hover:text-[#1ed760] max-lg:text-sm font-normal underline underline-offset-2 self-end text-right"
                        href={post.link}
                        aria-label={`Read More about ${post.title.rendered}`}
                      >
                        Read more
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
          </div>
        </section>
      </DeferredSection>
      <AnimatePresence>
        {showScrollIcon && (
          <motion.div
            className="fixed bottom-6 right-6 z-50 w-12 h-12 hover:scale-110 transition-transform duration-300 cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            title="Back to top"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <span className="border-2 border-white rounded-full w-10 h-10 inline-block ">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100"
                fill="none"
                className="w-full h-full pb-[3px]"
              >
                <polyline
                  points="35,60 50,45 65,60"
                  stroke="white"
                  strokeWidth="9"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </motion.div>
        )}
      </AnimatePresence>
      <Faq />
    </>
  );
};
